// Legal version + document URLs, mirroring iOS Constants.Legal. The version
// string is forwarded to /auth/register so the server records which ToS/Privacy
// revision the user accepted (tos_accepted_at / privacy_accepted_at). Bump this
// in lockstep with the iOS value and the backend TOS_VERSION/PRIVACY_VERSION.
export const LEGAL_VERSION = "2026-06-04";
export const TOS_URL = "https://edupause.app/terms";
export const PRIVACY_URL = "https://edupause.app/privacy";
